import { Table } from '@chakra-ui/react';
import { ComponentProps } from 'react';

type ThProps = ComponentProps<typeof Table.ColumnHeader>;

export const Th = (props: ThProps) => (
  <Table.ColumnHeader
    textTransform="none"
    fontSize="sm"
    color="single.black"
    borderBottomColor="single.deepGray"
    py={5}
    {...props}
  />
);
